import { render } from "./F2Tabstrip.vue?vue&type=template&id=dadfc60a&ts=true"
import script from "./F2Tabstrip.vue?vue&type=script&lang=ts"
export * from "./F2Tabstrip.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__